// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'name',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'hotel',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'bed_type',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'capacity',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'room_size',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'image',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'short_description',
    label: '',
    Object: 'value',
    width: '150'
  }]
}
